import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';

// Pages
import NotFoundPage from './pages/NotFoundPage';
import InterestFormPage from './pages/interest/InterestForm';
import CustomersProductList from './pages/products/CustomersProductList';
import CustomersProductDetails from './pages/products/CustomersProductDetails';
import AboutUsPage from './pages/AboutUsPage';
import CustomersPage from './pages/CustomersPage';
import SuppliersPage from './pages/SuppliersPage';
import FaqMunicipalities from './pages/FaqMunicipalities';
import LocationsPage from './pages/LocationsPage';
import MunicipalitiesInterestFormPage from './pages/interest/MunicipalitiesInterestForm';
import TermsPage from './pages/TermsPage';
import ImpressumPage from './pages/ImpressumPage';
import SocialLinksPage from './pages/SocialLinksPage';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import ContactPage from './pages/ContactPage';
import ScrollArrows from './components/UI/ScrollArrows';
import CookieBanner from './components/UI/CookieBanner';

// Slider
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function HashScrollHandler() {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) {
      return;
    }

    const targetId = location.hash.slice(1);
    const scrollToTarget = () => {
      const targetElement = document.getElementById(targetId);
      if (!targetElement) {
        return false;
      }

      targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return true;
    };

    if (scrollToTarget()) {
      return;
    }

    const timeoutId = window.setTimeout(scrollToTarget, 100);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [location.hash, location.pathname]);

  return null;
}

function AppLayout() {
  const location = useLocation();
  const hideHeader = location.pathname === "/links";
  const hideFooter = location.pathname === "/links";

  return (
    <div className="app">
      <HashScrollHandler />
      {!hideHeader && <Header />}
      <main>
        <Routes>
          {/* Customers Routes */}
          <Route path="/" element={<CustomersProductList />} />
          <Route path="/produkte/:id" element={<CustomersProductDetails />} />
          <Route path="/fuer-kunden" element={<CustomersPage />} />
          <Route path="/fuer-lieferanten" element={<SuppliersPage />} />
          <Route path="/ueber-uns" element={<AboutUsPage />} />
          <Route path="/fuer-gemeinden" element={<FaqMunicipalities />} />
          <Route path="/standorte" element={< LocationsPage />} />
          <Route path="/datenschutz" element={< TermsPage />} />
          <Route path="/impressum" element={< ImpressumPage />} />
          <Route path="" element={<Navigate to="/" />} />

          {/* Interests Routes */}
          <Route path="/produzentenformular" element={<InterestFormPage />} />
          <Route path="/gemeindeformular" element={<MunicipalitiesInterestFormPage />} />
          <Route path="/kontakt" element={<ContactPage />} />
          <Route path="/links" element={<SocialLinksPage />} />

          {/* 404 Page */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        <CookieBanner />
      </main>

      <ScrollArrows />

      {!hideFooter && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
